export default __webpack_public_path__ + "static/media/ActivityExl.fe033939.xlsx";